import React, { Fragment } from "react";

// The final character class excludes common prose punctuation so that
// trailing chars like `.`, `)`, `,` in "See https://example.com." are
// not swallowed into the href.
const URL_PATTERN = /(https?:\/\/[^\s<]*[^\s<.,;:!?)"'])/;

/**
 * Renders plain text with URLs converted to clickable links that open in a new tab.
 * @param text - The plain text content to linkify
 */
export const LinkifiedText: React.FC<{ text: string }> = ({ text }) => {
  const parts = text.split(URL_PATTERN);

  return (
    <>
      {parts.map((part, i) =>
        i % 2 === 1 ? (
          <a
            key={i}
            href={part}
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-600 underline hover:text-blue-800"
          >
            {part}
          </a>
        ) : (
          <Fragment key={i}>{part}</Fragment>
        ),
      )}
    </>
  );
};
